import Vue from 'vue'
import App from './App.vue'
import MintUI from 'mint-ui'
import router from './router.js'
import store from './store/index.js'
import "mint-ui/lib/style.css"
import infiniteScroll from 'vue-infinite-scroll'
import sdk from './utils/miniSDK'
import "./style/index.scss";
import "./skin/skin.css";
import { WebTrack } from 'lq-common'
import {getTrackKey,parseUrl,getPlatform} from './utils/utils'
Vue.use(infiniteScroll)
Vue.config.productionTip = false
Vue.use(MintUI)

Vue.prototype.sdk = sdk;
//数据埋点插入
(function(){
  
  let {openid,appId,platform} =parseUrl(location.href,['openid','appId','platform'])
  console.log("sdkname:::",getPlatform(platform))
  let key =getTrackKey(appId)
  if(!key){
    return
  }
  Vue.prototype.WebTrack = WebTrack
  window._webTrack = WebTrack
  WebTrack.init({
    appKey: key,
    serverUrl: 'https://big-data.leqi.us/api',
    Vue: Vue,
    Router: router,
    ...platform&&{platform:getPlatform(platform)}
  })
  openid && WebTrack.login(openid)
})()


router.beforeEach((to, from, next) => {
  store.commit('HANDLE_TRANCE',to.name)
  let data = to.query;
  
  if (data.platform) {
    //初始化数据
    console.log('data.platform:',data.platform)
    sdk.init(data.platform);
    data.skin = data.skin? data.skin : "skin1";
    //解决新用户从spec.vue再跳转到tutorial.vue再返回丢失openid等的数据问题（导致了其他vuex状态混款的问题）
    !store.state.platformInfo.openid && store.commit('RECORD_PLATFORMINFO', data);
    // console.log(`./skin/${data.skin}.css`)
    // require(`./skin/skin.css`);
  }
  //每当有extra就存储,为了在创建订单那边传入
  if(data.extra){
    store.commit('RECORD_EXTRAINFO', data.extra);
  }
  // 解决项目跳转小程序再跳转回来的vuex数据丢失
  if (!store.state.processedPhoto.specName) {
    //当vuex数据丢失时才去本地获取缓存
    let d = JSON.parse(localStorage.getItem("makephoto") || "{}");
    store.commit('MAKE_PHOTO', d);
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if ((from.path === '/orderList' && to.path === '/preview') || (from.path === '/orderList' && to.path === '/print')) {
    next(false);
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')